import { DISTRIBUTOR } from '../constants/distributor';

export const devDistributorClientUid = {
  [DISTRIBUTOR.MOCHIPAY]:
    '307e7e9c9434047529e5d7374c60ba4ca5e59ae31e4cb3973e0f12e096112ab6',
  [DISTRIBUTOR.AUTOPASS]:
    '8b19e1c872facc0333a62cb94691240cd885e82661c823d92b24b639e7bff1aa',
  [DISTRIBUTOR.CATHAYMR]:
    'b9fcf809e328db19afa070bff10df85b20bd960b5fe2acc544721018db616f60',
  [DISTRIBUTOR.CPCPAY]:
    'bcff0c33c2dc6a79babb27e4809d7429d17a7758d35f861c42ddf36e6c10b00c',
  [DISTRIBUTOR.CITIMKT]:
    '08f82dd8a4b021a5d80188be76094ea115ef4f1a89811356fb0e4cce9aad3961',
  [DISTRIBUTOR.LINE_BANK]: 'BFLA0qfahaAJlC1SxJpu5EtUvc8wSCXDmDR3hmlOn3Y',
  [DISTRIBUTOR.IKNOW99]: '7dJqyHNieVRJ7sFofvEElAi1X7Tj5DAF_MCe3s6S7cc',
  [DISTRIBUTOR.AUTO_PARTNER]: 'OO_IGjM0NFAfKH2UC6nL2f-StRFcjDvFtcTnGiDyEbc',
  [DISTRIBUTOR.NPCPAY]: '77_fkgtIBKNsPqRM5Eo-UEkNv5aNZmMnDFayNLtB1dE',
  [DISTRIBUTOR.ENTERPRISE]:
    'd451e968d472cb29ced4c149f805f67eab553198bf374dfa3a3bb9432a3b2304',
  [DISTRIBUTOR.UAT]:
    'b9fcf809e328db19afa070bff10df85b20bd960b5fe2acc544721018db616f60',
  [DISTRIBUTOR.RICHART_LIFE]: 'eSp4yGLpr0dthouTOlZVPuXenEpGY2m4s_q7NFBkD2I',
  [DISTRIBUTOR.MYTOYOTA]: 'DDXMS6iu4Gqa_hjAI3GNW82PHhgD5RVsfMozAeDwWX4',
};

export const prodDistributorClientUid = {
  [DISTRIBUTOR.MOCHIPAY]:
    'd3e444edf38a3bdc85834c61e03ab6480e2844c3ed4bc227f8775dad1bd862e4',
  [DISTRIBUTOR.AUTOPASS]:
    '97cae66ea75dc00c66c289ad9296f42911caec3f2d8c328b62e3350ec0699188',
  [DISTRIBUTOR.CATHAYMR]:
    '492bdb81e6c7d2b711a72ac58247970a8b2b420f3e0d0e83d6fff1c77d210247',
  [DISTRIBUTOR.CPCPAY]:
    'faaa5a2d6cbe1ce16b6830efac52c128d202309a07309a7afdef023c058361fe',
  [DISTRIBUTOR.CITIMKT]:
    'cb41a7c3c8aa249fce70e78c8c3c8d0e91b32c3263fee247769e1c6a157bac19',
  [DISTRIBUTOR.LINE_BANK]: '2ecAMkCFnu50162eHJTwTRgzd3QwhrgsqMj14zQ0mnc',
  [DISTRIBUTOR.IKNOW99]: 'PDNMGnwiHpH0vonZuJQCYU8WaZRd8B4SdbCfMr5jNdA',
  [DISTRIBUTOR.AUTO_PARTNER]: 'EP6DskS5UXZ4lgFmIQcHu7NGpyzbwzLvr8VAIqqXecE',
  [DISTRIBUTOR.NPCPAY]: 'vXqMc68EGmKxu_UoGRdGlb4cJRbQY1pohY_5VrODBpo',
  [DISTRIBUTOR.ENTERPRISE]:
    '51c8cf7db7e683e0241042d7bc27e5779a0545c07e89b9fdfdebf96fecfff8a2',
  [DISTRIBUTOR.UAT]:
    '492bdb81e6c7d2b711a72ac58247970a8b2b420f3e0d0e83d6fff1c77d210247',
  [DISTRIBUTOR.RICHART_LIFE]: 'zFgiE9AvgEODIfR97JCe4Yb5q0mZCgGgs-0PaLU9IIw',
  [DISTRIBUTOR.MYTOYOTA]: 'pMDOSgOlNkQQWVd5RUlPQ5lVh_qACgxS77RGi0hhqlM',
};
